export default __webpack_public_path__ + "static/media/recent-test.6759795b.svg";